import React, { useEffect } from "react";
import { useAPI } from "../../hooks";
import { useDispatch, useSelector } from "react-redux";
import { updateSetting } from "../../redux/slices";
import { storeSettingTypes } from "../../redux/utils";
import { Widget, addResponseMessage, toggleMsgLoader, renderCustomComponent } from "react-chat-widget";
import "react-chat-widget/lib/styles.css";

export const WidgetMain = ({ store_subdomain, shopifyStoreName }) => {
  const dispatch = useDispatch();
  const storeConfigState = useSelector((state) => state.storeSettings);

  const { CHATGPT_INITIAL_API, CHATGPT_CHAT_ADD_API, CHATGPT_IMAGE_UPLOAD_API } = useAPI();
  const useWidgetData = () => {
    const sessionId = useSelector((state) => state.storeSettings.sessionID);
    return [sessionId];
  };
  let [sessionId] = useWidgetData();

  const addCloseButton = () => {
    try {
      const close_button = document.getElementsByClassName("close-button")[0];
      if (!close_button) {
        const closeButton = document.createElement("button");
        const header = document.querySelector(".rcw-header");
        const widget = document.getElementsByClassName("rcw-launcher")[0];

        closeButton.classList.add("close-button");
        closeButton.innerHTML = "x";
        header.appendChild(closeButton);

        closeButton.addEventListener("click", () => {
          widget.click();
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  let isChatDataInitialized = false;

  useEffect(() => {
    const launcher = document.querySelector(".rcw-launcher");
    const handleLauncherClick = async () => {
      try {
        if (!isChatDataInitialized) {
          toggleMsgLoader();
          if (store_subdomain) {
            const response = await fetch(
              `${CHATGPT_INITIAL_API}?store=${shopifyStoreName}`
            );
            
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const data = await response.json();
            addResponseMessage(data?.message);
            dispatch(
              updateSetting({
                key: storeSettingTypes.CHAT_SESSION_ID,
                value: data?.session_id,
              })
            );
            isChatDataInitialized = true;
          } else {
            addResponseMessage(
              "It seems we're unable to identify the store this widget is on."
            );
          }
          toggleMsgLoader();
        }
      } catch (error) {
        console.log(error);
        addResponseMessage(
          "Something went wrong while processing your message."
        );
        toggleMsgLoader();
      }
    };
    launcher.addEventListener("click", handleLauncherClick);
  }, []);

  useEffect(() => {
    const link = document.getElementById("saara-chatgpt-widget-link-id");
    const widget = document.getElementsByClassName("rcw-launcher")[0];
    if (link) {
      link.addEventListener("click", () => {
        widget.click();
      });
      const handleDocumentClick = () => {
        addCloseButton();
      };
      document.addEventListener("click", handleDocumentClick);
    }
  }, []);

  const ImageUploadIcon = (props) => {
    return (
      <div class="chat_upload_button" onClick={props.onClick}>
        Upload images &nbsp;
        <i className="fa fa-upload"></i>
      </div>
    );
  }

  const handleImageUpload = async (condition_check, text_input) => {
    try {
      const enable_image_upload = condition_check?.enable_upload_button;
      if (enable_image_upload) {
        const input = document.createElement("input");
        input.type = "file";
        input.accept = "image/*";
        if (enable_image_upload !== "one") {
          input.multiple = true;
        }
        const files = await new Promise((resolve) => {
          input.addEventListener("change", (event) => {
            resolve(event.target.files);
          });
          input.click();
        });
        if (files.length <= 4) {
          const fileDataArray = await Promise.all(
            Array.from(files).map(async (file) => {
              const reader = new FileReader();
              reader.readAsDataURL(file);
              return await new Promise((resolve, reject) => {
                reader.onload = () => resolve(reader.result);
                reader.onerror = (error) => reject(error);
              });
            })
          );
          const response = await fetch(
            `${CHATGPT_IMAGE_UPLOAD_API}`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                session_id: sessionId,
                image_list: fileDataArray,
              }),
            }
          );
          if (response.ok) {
            console.log("Success in uploading images");
            text_input.contentEditable = true;
            text_input.setAttribute("placeholder", "Type a message...");
            addResponseMessage("Images uploaded successfully.");
            const upload_buttons = document.getElementsByClassName("chat_upload_button");
            for (let i = 0; i < upload_buttons.length; i++) {
              upload_buttons[i].classList.add("disabled_button");
            }
            handleNewUserMessage("Images uploaded successfully.");
          } else {
            console.log("Error in uploading images");
            addResponseMessage("Unable to upload images. Please try again.");
          }
        } else {
            text_input.setAttribute("placeholder", "Please do not upload more than 4 images.");
        }
      }
    } catch (error) {
      console.log(error);
      addResponseMessage("Something went wrong while uploading images. Please try again.");
    }
  };

  const handleNewUserMessage = async (newMessage) => {
    console.log(`New message incoming! : ${newMessage}`);
    try {
      toggleMsgLoader();
      const textboxes = document.getElementsByClassName("rcw-input");
      textboxes[0].contentEditable = false;
      const response = await fetch(
        `${CHATGPT_CHAT_ADD_API}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            session_id: sessionId,
            message: newMessage,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      textboxes[0].contentEditable = true;
      textboxes[0].focus();
      if (data?.message) {
        addResponseMessage(data?.message);
      }
      toggleMsgLoader();
      if (data?.condition_check?.enable_upload_button) {
        if (textboxes && data?.condition_check?.enable_upload_button !== "optional") {
          textboxes[0].contentEditable = false;
          textboxes[0].setAttribute("placeholder", "Upload images before proceeding with the Returns.");
        }
        renderCustomComponent(ImageUploadIcon, { onClick: () => handleImageUpload(data?.condition_check, textboxes[0]) });
      }
    } catch (error) {
      console.log(error);
      addResponseMessage("Something went wrong while processing your message.");
      toggleMsgLoader();
      textboxes[0].contentEditable = true;
      textboxes[0].focus();
    }
  };

  return (
    <Widget
      handleNewUserMessage={handleNewUserMessage}
      //profileAvatar={logo}
      title={storeConfigState?.themeConfig?.landing_page_left_title}
      subtitle=""
      className="my-chat-widget"
    />
  );
};
